import { getMerchantId } from "@/services/users.service";
import { useQuery } from "@tanstack/react-query";

export const useMerchantId = (userId, enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["merchant-id", userId],
    queryFn: () => getMerchantId({ userId }),
    enabled: enabled && !!userId,
    ...options,
  });
};
